export enum InformationStatus {
  Danger = 'danger',
  Information = 'information',
  Success = 'success',
  Warning = 'warning',
}
